import {
  MATERIAL_TYPE,
  SUBSECTION_TYPE,
  VIDEO_PROVIDER,
  CONTENT_DATA,
  VIDEO_ERROR_TYPE,
  VIDEO_SOURCE_TYPE,
} from './constant';
import Content from './Content';
export { default as VideoBox } from './VideoBox';
export { default as ArticleBox } from './ArticleBox';

export {
  MATERIAL_TYPE,
  SUBSECTION_TYPE,
  VIDEO_PROVIDER,
  CONTENT_DATA,
  VIDEO_ERROR_TYPE,
  VIDEO_SOURCE_TYPE,
};

export default Content;
